module.exports = __webpack_public_path__ + "static/media/23.b9a16d0c.mp3";